export var RecordState;
(function (RecordState) {
    RecordState[RecordState["Default"] = 0] = "Default";
    RecordState[RecordState["New"] = 10] = "New";
    RecordState[RecordState["OpenInWeb"] = 20] = "OpenInWeb";
    RecordState[RecordState["SentFromWeb"] = 30] = "SentFromWeb";
    RecordState[RecordState["ProposalGiven"] = 40] = "ProposalGiven";
    RecordState[RecordState["ProposalRead"] = 41] = "ProposalRead";
    RecordState[RecordState["DecisionGiven"] = 50] = "DecisionGiven";
    RecordState[RecordState["DecisionSentManually"] = 51] = "DecisionSentManually";
    RecordState[RecordState["Processed"] = 60] = "Processed";
    RecordState[RecordState["Canceled"] = 61] = "Canceled";
    RecordState[RecordState["Deleted"] = 62] = "Deleted";
})(RecordState || (RecordState = {}));
